document.addEventListener("DOMContentLoaded", () => {

    async function fetchPodcast(url: string, targetDiv: HTMLElement) {
        const response = await fetch(url);
        if (response.ok) {
            const html = await response.text();
            targetDiv.innerHTML = html;
        } else {
            console.error("Failed to fetch podcast list:", response.status, response.statusText);
        }
    };

    const podcastFrDiv = document.getElementById("podcast-list-fr") as HTMLElement;
    const podcastEsDiv = document.getElementById("podcast-list-es") as HTMLElement;

    if (podcastFrDiv) {
        fetchPodcast("https://www.reveillenoscoeurs.com/podcast/_podcast_list.html", podcastFrDiv);
    }
    if (podcastEsDiv) {
        fetchPodcast("https://www.avivanuestroscorazones.com/podcast/_podcast_list.html", podcastEsDiv);
    }



});